module.exports = __webpack_public_path__ + "static/media/step5_j.fd204772.png";